import { Tooltip } from '@lokalise/louis';
import { forwardRef } from 'react';

import type { NavItemIcon } from '../../../../types/navigation';
import NavItemContents from './NavItemContents';
import type { IconType } from './styles';
import { NavButton, NavLink } from './styles';

const disabledItemMessage = 'You do not have access to ';

interface NavigationBlockItemProps {
    label: string;
    icon?: NavItemIcon;
    small: boolean;
    badge?: number;
    disabled?: boolean;
    active?: boolean;
    onClick?: () => void;
    href?: string;
}

const NavigationBlockItem = forwardRef<HTMLButtonElement, NavigationBlockItemProps>(
    (
        { label, icon, small, href = '', disabled = false, active = false, badge = undefined, onClick = undefined },
        ref,
    ) => (
        <div>
            <Tooltip tooltip={disabled ? disabledItemMessage + label : label}>
                <div>
                    {onClick || disabled || !href ? (
                        <NavButton
                            ref={ref}
                            disabled={disabled}
                            onClick={onClick}
                            $icon={icon as IconType}
                            $small={small}
                            aria-label={label}
                            aria-expanded={active}
                        >
                            <NavItemContents icon={icon} small={small} badge={badge} />
                        </NavButton>
                    ) : (
                        <NavLink href={href} $icon={icon as IconType} $small={small} aria-label={label}>
                            <NavItemContents icon={icon} small={small} badge={badge} />
                        </NavLink>
                    )}
                </div>
            </Tooltip>
        </div>
    ),
);
NavigationBlockItem.displayName = 'NavigationBlockItem';

export default NavigationBlockItem;
